import { css } from "styled-components";

import { breakpoints } from "./index";

const spacing = {
    /* mobile -> tablet/desktop */
    /* name represents desktop spacing */
    margin: {
        "8-t-b": css`
            margin-top: 0.5rem;
            margin-bottom: 0.5rem;
        `,
        "8-t": css`
            margin-top: 0.5rem;
        `,
        "8-b": css`
            margin-bottom: 0.5rem;
        `,
        "16-t-b": css`
            margin-top: 1rem;
            margin-bottom: 1rem;
        `,
        "16-t": css`
            margin-top: 1rem;
        `,
        "16-b": css`
            margin-bottom: 1rem;
        `,
        "24-t-b": css`
            margin-top: 1.5rem;
            margin-bottom: 1.5rem;
        `,
        "24-t": css`
            margin-top: 1.5rem;
        `,
        "24-b": css`
            margin-bottom: 1.5rem;
        `,
        "32-t-b": css`
            margin-top: 1.5rem;
            margin-bottom: 1.5rem;

            @media (min-width: 48rem) {
                margin-top: 2rem;
                margin-bottom: 2rem;
            }
        `,
        "32-t": css`
            margin-top: 1.5rem;

            @media (min-width: 48rem) {
                margin-top: 2rem;
            }
        `,
        "32-b": css`
            margin-bottom: 1.5rem;

            @media (min-width: 48rem) {
                margin-bottom: 2rem;
            }
        `,
        "40-t-b": css`
            margin-top: 2rem;
            margin-bottom: 2rem;

            @media (min-width: 48rem) {
                margin-top: 2.5rem;
                margin-bottom: 2.5rem;
            }
        `,
        "40-t": css`
            margin-top: 2rem;

            @media (min-width: 48rem) {
                margin-top: 2.5rem;
            }
        `,
        "40-b": css`
            margin-bottom: 2rem;

            @media (min-width: 48rem) {
                margin-bottom: 2.5rem;
            }
        `,
        "48-t-b": css`
            margin-top: 2rem;
            margin-bottom: 2rem;

            @media (min-width: 48rem) {
                margin-top: 3rem;
                margin-bottom: 3rem;
            }
        `,
        "48-t": css`
            margin-top: 2rem;

            @media (min-width: 48rem) {
                margin-top: 3rem;
            }
        `,
        "48-b": css`
            margin-bottom: 2rem;

            @media (min-width: 48rem) {
                margin-bottom: 3rem;
            }
        `,
        "64-t-b": css`
            margin-top: 3rem;
            margin-bottom: 3rem;

            @media (min-width: 48rem) {
                margin-top: 4rem;
                margin-bottom: 4rem;
            }
        `,
        "64-t": css`
            margin-top: 3rem;

            @media (min-width: 48rem) {
                margin-top: 4rem;
            }
        `,
        "64-b": css`
            margin-bottom: 3rem;

            @media (min-width: 48rem) {
                margin-bottom: 4rem;
            }
        `,
        "128-t-b": css`
            margin-top: 4rem;
            margin-bottom: 4rem;

            @media (min-width: 48rem) {
                margin-top: 8rem;
                margin-bottom: 8rem;
            }
        `,
        "128-t": css`
            margin-top: 4rem;

            @media (min-width: 48rem) {
                margin-top: 8rem;
            }
        `,
        "128-b": css`
            margin-bottom: 4rem;

            @media (min-width: 48rem) {
                margin-bottom: 8rem;
            }
        `
    },
    padding: {
        "8-t-b": css`
            padding-top: 0.5rem;
            padding-bottom: 0.5rem;
        `,
        "8-t": css`
            padding-top: 0.5rem;
        `,
        "8-b": css`
            padding-bottom: 0.5rem;
        `,
        "16-t-b": css`
            padding-top: 1rem;
            padding-bottom: 1rem;
        `,
        "16-t": css`
            padding-top: 1rem;
        `,
        "16-b": css`
            padding-bottom: 1rem;
        `,
        "24-t-b": css`
            padding-top: 1.5rem;
            padding-bottom: 1.5rem;
        `,
        "24-t": css`
            padding-top: 1.5rem;
        `,
        "24-b": css`
            padding-bottom: 1.5rem;
        `,
        "32-t-b": css`
            padding-top: 1.5rem;
            padding-bottom: 1.5rem;

            @media (min-width: 48rem) {
                padding-top: 2rem;
                padding-bottom: 2rem;
            }
        `,
        "32-t": css`
            padding-top: 1.5rem;

            @media (min-width: 48rem) {
                padding-top: 2rem;
            }
        `,
        "32-b": css`
            padding-bottom: 1.5rem;

            @media (min-width: 48rem) {
                padding-bottom: 2rem;
            }
        `,
        "40-t-b": css`
            padding-top: 2rem;
            padding-bottom: 2rem;

            @media (min-width: 48rem) {
                padding-top: 2.5rem;
                padding-bottom: 2.5rem;
            }
        `,
        "40-t": css`
            padding-top: 2rem;

            @media (min-width: 48rem) {
                padding-top: 2.5rem;
            }
        `,
        "40-b": css`
            padding-bottom: 2rem;

            @media (min-width: 48rem) {
                padding-bottom: 2.5rem;
            }
        `,
        "48-t-b": css`
            padding-top: 2rem;
            padding-bottom: 2rem;

            @media (min-width: 48rem) {
                padding-top: 3rem;
                padding-bottom: 3rem;
            }
        `,
        "48-t": css`
            padding-top: 2rem;

            @media (min-width: 48rem) {
                padding-top: 3rem;
            }
        `,
        "48-b": css`
            padding-bottom: 2rem;

            @media (min-width: 48rem) {
                padding-bottom: 3rem;
            }
        `,
        "64-t-b": css`
            padding-top: 3rem;
            padding-bottom: 3rem;

            @media (min-width: 48rem) {
                padding-top: 4rem;
                padding-bottom: 4rem;
            }
        `,
        "64-t": css`
            padding-top: 3rem;

            @media (min-width: 48rem) {
                padding-top: 4rem;
            }
        `,
        "64-b": css`
            padding-bottom: 3rem;

            @media (min-width: 48rem) {
                padding-bottom: 4rem;
            }
        `,
        "128-t-b": css`
            padding-top: 4rem;
            padding-bottom: 4rem;

            @media (min-width: 48rem) {
                padding-top: 8rem;
                padding-bottom: 8rem;
            }
        `,
        "128-t": css`
            padding-top: 4rem;

            @media (min-width: 48rem) {
                padding-top: 8rem;
            }
        `,
        "128-b": css`
            padding-bottom: 4rem;

            @media (min-width: 48rem) {
                padding-bottom: 8rem;
            }
        `
    }
};

/* TODO - refactor how we are doing this */
/* lingo team does this: https://github.com/TheNounProject/lingo-core/blob/master/src/constants/styles. */
/* TODO - deprecate "spacing" and rename "spacing2020" to "spacing" once it's been removed/refactored */

const spacing2020WithoutBreakpoints = {
    Spacing5XLMobile: css`
        padding-bottom: 4rem; /* 64px */
    `,
    Spacing5XLTablet: css`
        padding-bottom: 6.125rem; /* 98px */
    `,
    Spacing5XLDesktop: css`
        padding-bottom: 8rem; /* 128px */
    `,
    Spacing4XLMobile: css`
        padding-bottom: 3rem; /* 48px */
    `,
    Spacing4XLTablet: css`
        padding-bottom: 3.5rem; /* 56px */
    `,
    Spacing4XLDesktop: css`
        padding-bottom: 4rem; /* 64px */
    `,
    Spacing4XLTopMobile: css`
        padding-top: 3rem; /* 48px */
    `,
    Spacing4XLTopTablet: css`
        padding-top: 3.5rem; /* 56px */
    `,
    Spacing4XLTopDesktop: css`
        padding-top: 4rem; /* 64px */
    `,
    Spacing3XLMobile: css`
        padding-bottom: 2rem; /* 32px */
    `,
    Spacing3XLTablet: css`
        padding-bottom: 2.5rem; /* 40px */
    `,
    Spacing3XLDesktop: css`
        padding-bottom: 3rem; /* 48px */
    `,
    Spacing2XLMobile: css`
        padding-bottom: 2rem; /* 32px */
    `,
    Spacing2XLTablet: css`
        padding-bottom: 2.25rem; /* 36px */
    `,
    Spacing2XLDesktop: css`
        padding-bottom: 2.5rem; /* 40px */
    `,
    SpacingXLMobile: css`
        padding-bottom: 1.5rem; /* 24px */
    `,
    SpacingXLTablet: css`
        padding-bottom: 1.75rem; /* 28px */
    `,
    SpacingXLDesktop: css`
        padding-bottom: 2rem; /* 32px */
    `,
    SpacingLGMobile: css`
        padding-bottom: 1.5rem; /* 24px */
    `,
    SpacingLGTablet: css`
        padding-bottom: 1.5rem; /* 24px */
    `,
    SpacingLGDesktop: css`
        padding-bottom: 1.5rem; /* 24px */
    `,
    SpacingMDMobile: css`
        padding-bottom: 1rem; /* 16px */
    `,
    SpacingMDTablet: css`
        padding-bottom: 1rem; /* 16px */
    `,
    SpacingMDDesktop: css`
        padding-bottom: 1rem; /* 16px */
    `,
    SpacingSMMobile: css`
        padding-bottom: 0.5rem; /* 8px */
    `,
    SpacingSMTablet: css`
        padding-bottom: 0.5rem; /* 8px */
    `,
    SpacingSMDesktop: css`
        padding-bottom: 0.5rem; /* 8px */
    `,
    SpacingXSMobile: css`
        padding-bottom: 0.25rem; /* 4px */
    `,
    SpacingXSTablet: css`
        padding-bottom: 0.25rem; /* 4px */
    `,
    SpacingXSDesktop: css`
        padding-bottom: 0.25rem; /* 4px */
    `,
    SpacingSectionContainerMobile: css`
        padding: 4rem 0.9375rem; /* 64px 15px */
    `,
    SpacingSectionContainerTablet: css`
        padding: 6.125rem 1.25rem; /* 98px 20px */
    `,
    SpacingSectionContainerDesktop: css`
        padding: 8rem 1.5rem; /* 128px 24px */
    `,
    SpacingHeroMobile: css`
        padding-top: 4rem; /* 64px */
        padding-bottom: 4rem; /* 64px */
    `,
    SpacingHeroTablet: css`
        padding-top: 5rem; /* 80px */
        padding-bottom: 6.125rem; /* 98px */
    `,
    SpacingHeroDesktop: css`
        padding-top: 6rem; /* 96px */
        padding-bottom: 8rem; /* 128px */
    `,
    SpacingHeroLandingMobile: css`
        padding-top: 3rem; /* 48px */
        padding-bottom: 3rem; /* 48px */
    `,
    SpacingHeroLandingTablet: css`
        padding-top: 3.5rem; /* 56px */
        padding-bottom: 3.5rem; /* 56px */
    `,
    SpacingHeroLandingDesktop: css`
        padding-top: 4rem; /* 64px */
        padding-bottom: 4rem; /* 64px */
    `
};

const spacing2020HasBreakpoints = {
    Spacing5XL: `
        /* Mobile: */
        ${spacing2020WithoutBreakpoints.Spacing5XLMobile};

        /* Tablet: */
        @media (min-width: ${breakpoints.md}rem) {
            ${spacing2020WithoutBreakpoints.Spacing5XLTablet};
        }

        /* Desktop: */
        @media (min-width: ${breakpoints.lg}rem) {
            ${spacing2020WithoutBreakpoints.Spacing5XLDesktop};
        }
    `,
    Spacing4XL: `
        /* Mobile: */
        ${spacing2020WithoutBreakpoints.Spacing4XLMobile};

        /* Tablet: */
        @media (min-width: ${breakpoints.md}rem) {
            ${spacing2020WithoutBreakpoints.Spacing4XLTablet};
        }

        /* Desktop: */
        @media (min-width: ${breakpoints.lg}rem) {
            ${spacing2020WithoutBreakpoints.Spacing4XLDesktop};
        }
    `,
    Spacing4XLTop: `
        /* Mobile: */
        ${spacing2020WithoutBreakpoints.Spacing4XLTopMobile};

        /* Tablet: */
        @media (min-width: ${breakpoints.md}rem) {
            ${spacing2020WithoutBreakpoints.Spacing4XLTopTablet};
        }

        /* Desktop: */
        @media (min-width: ${breakpoints.lg}rem) {
            ${spacing2020WithoutBreakpoints.Spacing4XLTopDesktop};
        }
    `,
    Spacing3XL: `
        /* Mobile: */
        ${spacing2020WithoutBreakpoints.Spacing3XLMobile};

        /* Tablet: */
        @media (min-width: ${breakpoints.md}rem) {
            ${spacing2020WithoutBreakpoints.Spacing3XLTablet};
        }

        /* Desktop: */
        @media (min-width: ${breakpoints.lg}rem) {
            ${spacing2020WithoutBreakpoints.Spacing3XLDesktop};
        }
    `,
    Spacing2XL: `
        /* Mobile: */
        ${spacing2020WithoutBreakpoints.Spacing2XLMobile};

        /* Tablet: */
        @media (min-width: ${breakpoints.md}rem) {
            ${spacing2020WithoutBreakpoints.Spacing2XLTablet};
        }

        /* Desktop: */
        @media (min-width: ${breakpoints.lg}rem) {
            ${spacing2020WithoutBreakpoints.Spacing2XLDesktop};
        }
    `,
    SpacingXL: `
        /* Mobile: */
        ${spacing2020WithoutBreakpoints.SpacingXLMobile};

        /* Tablet: */
        @media (min-width: ${breakpoints.md}rem) {
            ${spacing2020WithoutBreakpoints.SpacingXLTablet};
        }

        /* Desktop: */
        @media (min-width: ${breakpoints.lg}rem) {
            ${spacing2020WithoutBreakpoints.SpacingXLDesktop};
        }
    `,
    SpacingLG: `
        /* Mobile: */
        ${spacing2020WithoutBreakpoints.SpacingLGMobile};

        /* Tablet: */
        @media (min-width: ${breakpoints.md}rem) {
            ${spacing2020WithoutBreakpoints.SpacingLGTablet};
        }

        /* Desktop: */
        @media (min-width: ${breakpoints.lg}rem) {
            ${spacing2020WithoutBreakpoints.SpacingLGDesktop};
        }
    `,
    SpacingMD: `
        /* Mobile: */
        ${spacing2020WithoutBreakpoints.SpacingMDMobile};

        /* Tablet: */
        @media (min-width: ${breakpoints.md}rem) {
            ${spacing2020WithoutBreakpoints.SpacingMDTablet};
        }

        /* Desktop: */
        @media (min-width: ${breakpoints.lg}rem) {
            ${spacing2020WithoutBreakpoints.SpacingMDDesktop};
        }
    `,
    SpacingSM: `
        /* Mobile: */
        ${spacing2020WithoutBreakpoints.SpacingSMMobile};

        /* Tablet: */
        @media (min-width: ${breakpoints.md}rem) {
            ${spacing2020WithoutBreakpoints.SpacingSMTablet};
        }

        /* Desktop: */
        @media (min-width: ${breakpoints.lg}rem) {
            ${spacing2020WithoutBreakpoints.SpacingSMDesktop};
        }
    `,
    SpacingXS: `
        /* Mobile: */
        ${spacing2020WithoutBreakpoints.SpacingXSMobile};

        /* Tablet: */
        @media (min-width: ${breakpoints.md}rem) {
            ${spacing2020WithoutBreakpoints.SpacingXSTablet};
        }

        /* Desktop: */
        @media (min-width: ${breakpoints.lg}rem) {
            ${spacing2020WithoutBreakpoints.SpacingXSDesktop};
        }
    `,
    Spacing4XLHeroLanding: `
        /* Mobile: */
        ${spacing2020WithoutBreakpoints.SpacingHeroLandingMobile};

        /* Tablet: */
        @media (min-width: ${breakpoints.md}rem) {
            ${spacing2020WithoutBreakpoints.SpacingHeroLandingTablet};
        }

        /* Desktop: */
        @media (min-width: ${breakpoints.lg}rem) {
            ${spacing2020WithoutBreakpoints.SpacingHeroLandingDesktop};

            @media ${breakpoints.laptopHeightsRange} {
                ${spacing2020WithoutBreakpoints.SpacingHeroLandingTablet};
            }
        }
    `
};

export { spacing, spacing2020WithoutBreakpoints, spacing2020HasBreakpoints };
// ^^ spacing2020 name can be changed later - these will only apply bottom padding to elements.
// we are using padding because sometimes margins are used for centering things & we dont want to override that.
// the names follow the chart given to KZ by Design.
// we have 'withoutBreakpoints' because sometimes we need to import the individual padding into a file regardless of breakpoint;
//we have 'hasBreakpoints' because more often than not, we want a spacing to change with the breakpoint;  designs will tell us which to use. i used a different name than 'withBreakpoints' because it was too close to 'withoutBreakpoints' and i want it to be visibly different so we dont accidentally use the wrong one.
//places we may need to use the individual padding without the breakpoints is in headers for instance for  the height breakpoint.
